import { COMPANIES } from 'constants/Entities';
import BASE_CONFIG from 'containers/companies/EntityConfig';
import { getMarketingStatusColumn } from 'components/TableCells/MarketingStatusCell/column';
import { setMarketingConsentAccount } from 'services/MarketingConsentService';

const ALLOWED_COLS = ['name', 'responsible', 'companytype', 'email1'];
const PINNED_QUICK_FILTERS = ['marketingStatus', 'onlySelected'];
const READ_ONLY_PINNED_FILTERS = ['marketingStatus'];

export default ({ onClickCheckbox, selectionToken, marketingCampaignsEnabled, canEdit } = {}) => {
    const tableParams = {
        ...(onClickCheckbox ? { account: { onClickCheckbox } } : {}),
        marketingCampaignsEnabled,
        ...(canEdit !== undefined ? { canEdit } : {}),
    };
    const base = BASE_CONFIG(tableParams);

    const marketingColumn = getMarketingStatusColumn({
        minWidth: 160,
        setMarketingConsent: setMarketingConsentAccount,
        isReadOnly: true,
    });

    return {
        ...base,
        useFiltersDrawer: false,
        useViewsInFilters: false,
        useViewsInMenu: false,
        filterKey: 'recipientsAccounts',
        quickFilters: [...PINNED_QUICK_FILTERS],
        defaultFilters: [...PINNED_QUICK_FILTERS],
        readOnlyFilters: READ_ONLY_PINNED_FILTERS,
        readOnlyQuickFilters: READ_ONLY_PINNED_FILTERS,
        dontIgnoreTheseFilters: ['onlySelected'],
        columnSelectorSections: undefined,
        withEntitySelection: true,
        selectionFor: 'marketingCampaigns',
        selectionEntity: 'accounts',
        selectionToken,
        isLocalSelection: false,
        columnDefs: [
            ...base.columnDefs
                .filter((col) => ALLOWED_COLS.includes(col.colId))
                .map(({ width, suppressSizeToFit, ...col }) => ({ ...col, minWidth: width })),
            marketingColumn,
        ],
    };
};
